import { SListItemCard } from 'app/components/StaycationUI/List/SListItemCard/SListItemCard';
import type { Mode } from 'app/components/commons/Hotel/Types';
import { UploadList } from 'app/components/commons/Uploader/UploadList/UploadList';
import type { HotelDiscoverExperience } from 'app/typings/hotels/Hotel/HotelDiscover';

import './ExperienceListItem.scss';

export const ExperienceListItem = ({
  experience,
  mode,
  onToggle,
  isLegacy = false,
}: {
  experience: HotelDiscoverExperience;
  mode: Mode;
  onToggle: (value: boolean) => void;
  isLegacy?: boolean;
}) => {
  const experienceTitle = (
    <div className="staycation-discover-experience-item_title">
      {experience.name}
    </div>
  );

  const experienceURL = isLegacy
    ? `/activities/legacy/${experience.id}`
    : `/activities/${experience.id}`;

  return (
    <SListItemCard
      itemId={experience.id}
      checked={experience.discover}
      onToggle={onToggle}
      title={experienceTitle}
      displayDragHandle={mode === 'edit'}
      disableToggle={mode === 'view'}
      url={experienceURL}
      children={
        <UploadList
          pictures={experience.pictures || []}
          uploadingItems={{}}
          previewable
        />
      }
    />
  );
};
